import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OuiLoadingModule } from 'omnium-ui/loading';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [OuiLoadingModule],
})
export class LandingPageComponent {
  constructor() {}
}
